export const ErrorCode = {
  VALIDATION_ERROR: "VALIDATION_ERROR",
  PERMISSION_DENIED: "PERMISSION_DENIED",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  WORKFLOW_LOCKED: "WORKFLOW_LOCKED",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  TOKEN_REUSED: "TOKEN_REUSED",
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

export interface ProblemError {
  code: string;
  title: string;
  detail: string;
  fieldErrors?: Record<string, string | string[]> | string[];
  traceId?: string;
}
